import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import Pagination from '../layouts/pagination.jsx';
import DeleteComponent from '../../action/delete.jsx';
import AddLeave from './sections/add';
import moment from 'moment';

const Leaves = () => {
    const [leaves, setLeaves] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [selLeaveType, setSelLeaveType] = useState('');

    const fetchLeaves = async (currentPage) => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/leaves?page=${currentPage + 1}`)
            .then(response => {
                setLeaves(response.data.data);
                setPageCount(Math.ceil(response.data.meta.pagination.total / response.data.meta.pagination.per_page));
            })
            .catch(error => {
                console.error("Error fetching leaves!", error);
                setLeaves([]);
            });
    };

    useEffect(() => {
        fetchLeaves(currentPage);
    }, [currentPage]);
    
    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    // Search input handler
    const filteredItems = leaves.filter((item) => {
        var leaveType = selLeaveType;
        const matchesLeaveType = leaveType ? item.leave_type === leaveType : true;
        return matchesLeaveType;
    });

    return (
        <>    
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center timeLog">
                        <div className="col">
                            <h3 className="page-title">Leaves</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Leaves</li>
                            </ul>
                        </div>
                        <div className="col-auto float-end ms-auto">
                            <Link to="#" className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_leave">
                                <i className="fa-solid fa-plus"></i> Add Leave</Link>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4 mb-3">
                        <select className="form-control"
                            value={selLeaveType}
                            onChange={(event) => {setSelLeaveType(event.target.value)}}>
                                <option value="">Select Leave Type</option>
                                <option value="Regular">Regular</option>
                                <option value="Regular S.L Time">Regular S.L Time</option>
                                <option value="Medical (Medical Certificate Required)">Medical (Medical Certificate Required)</option>
                                <option value="Medical S.L Time">Medical S.L Time</option>
                        </select>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table">
                                        <thead>
                                            <tr>
                                                <th>Leave Type</th>
                                                <th>From</th>
                                                <th>To</th>
                                                <th>Reason</th>
                                                <th>Approved By</th>
                                                <th>Status</th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredItems.length > 0 ? (
                                                    filteredItems.map((leave) => (
                                                        <tr key={leave.id}>
                                                            <td>{leave.leave_type}</td>
                                                            <td>{leave.from_date} ({moment(leave.from_time, "HH:mm").format("hh:mm a")})</td>
                                                            <td>{leave.to_date} ({moment(leave.to_time, "HH:mm").format("hh:mm a")})</td>
                                                            <td className="leave-reason">{leave.reason}</td>
                                                            <td>{leave.requested_to_name}</td>
                                                            <td>
                                                                <div className="action-label">
                                                                    <div className="btn btn-white btn-sm btn-rounded" title={leave.status === '2' ? leave.not_permitted_reason : ""}>
                                                                        {leave.status === '0' &&
                                                                            <><i className="fa-regular fa-circle-dot text-purple"></i> Pending</>
                                                                        }
                                                                        {leave.status === '1' &&
                                                                            <><i className="fa-regular fa-circle-dot text-success"></i> Approved</>
                                                                        }
                                                                        {leave.status === '2' &&
                                                                            <><i className="fa-regular fa-circle-dot text-danger"></i> Declined</>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="text-end">
                                                                <div className="dropdown dropdown-action">
                                                                    <Link to="#" className="action-icon dropdown-toggle"
                                                                        data-bs-toggle="dropdown" aria-expanded="false">
                                                                            <i className="material-icons">more_vert</i></Link>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <DeleteComponent 
                                                                            url = "leaves"
                                                                            id = {leave.id}
                                                                            fetchData={fetchLeaves} />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="7" className="text-center">No records found</td>
                                                    </tr>
                                                )                                          
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Pagination pageCount={pageCount} handlePageClick={handlePageClick}/>
            </div>

            <AddLeave list={fetchLeaves}/>
        </>
    );
}

export default Leaves